import React, { memo } from 'react';
import ReactCountryFlag from 'react-country-flag';

const IsoFlag = memo(({ countryCode, size = 16, className = '' }) => {
  if (!countryCode) return null;

  return (
    <span
      className={`inline-flex items-center justify-center flex-shrink-0 overflow-hidden rounded-sm ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <ReactCountryFlag
        countryCode={countryCode}
        svg
        loading="lazy"
        style={{ width: size, height: size, display: 'block' }}
      />
    </span>
  );
});

IsoFlag.displayName = 'IsoFlag';

export default IsoFlag;
